import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
    thumbnailContainer: {
        maxHeight: '56px',
        maxWidth: '56px',
    },
    thumbnailTitle: {
        '&.MuiTypography-root': {
            paddingLeft: '12px',
            paddingRight: '4px',
        },
    },
}));
